import {Switch} from '@wandb/weave/components';
import React, {useState} from 'react';

import {SettingTitle} from '../../common/SettingTitle';
import {useMediaSettingsDrawerContext} from '../../MediaSettingsDrawerContextProvider';

export const AxesHandedness = () => {
  const {config, updateConfig, unsetConfigField} =
    useMediaSettingsDrawerContext();
  const [isRightHanded, setIsRightHanded] = useState(
    config.useRightHandedSystem === true
  );

  return (
    <div className="flex justify-between">
      <SettingTitle
        title="Right-handed system"
        configField="useRightHandedSystem"
        unsetConfigField={() => unsetConfigField('useRightHandedSystem')}
      />
      <Switch.Root
        data-test="axes-handedness-switch"
        checked={isRightHanded}
        onCheckedChange={newIsRightHanded => {
          setIsRightHanded(newIsRightHanded);
          updateConfig({useRightHandedSystem: newIsRightHanded});
        }}>
        <Switch.Thumb checked={isRightHanded} />
      </Switch.Root>
    </div>
  );
};
